import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import GetAppIcon from '@mui/icons-material/GetApp';


const CustomButton = styled(Button)(({ theme }) => ({
  textTransform: 'uppercase',
  background: theme.palette.primary.main,
  color: theme.palette.common.white,
  padding: '0.8rem 1.6rem',
  letterSpacing: theme.spacing(0.5),
  display: 'inline-block',
  transition: theme.transitions.create('all', {
    duration: theme.transitions.duration.short,
  }),
  fontSize: '0.875rem',
  border: '2px solid transparent',
  cursor: 'pointer',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
  borderRadius: '2rem',
  '&:hover': {
    background: 'transparent',
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
  },
}));

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function FileDownloadButton() {
  const handleDownloadClick = () => {
    const fileUrl = '/Cv/cv.docx';
    window.open('/Cv/cv.docx', '_blank');
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', 'cv.docx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <CustomButton
      component="label"
      variant="contained"
      startIcon={<GetAppIcon />}
      onClick={handleDownloadClick}
    >
      DOWNLOAD CV
      <VisuallyHiddenInput type="file" />
    </CustomButton>
  );
}
